export const AdminTeams = {
  "CustomerSuccess" : "customer_success",
}